import React from 'react';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Car from '@material-ui/icons/DirectionsCar';
import Book from '@material-ui/icons/Book'
import Hotel from '@material-ui/icons/Hotel';
import People from '@material-ui/icons/People';
import Photo from '@material-ui/icons/Photo';
import RSVP from '@material-ui/icons/Mail';
import GuestBook from '@material-ui/icons/BorderColor';
import Registry from '@material-ui/icons/CardGiftcard';
import QueueMusic from '@material-ui/icons/QueueMusic';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error from '@material-ui/icons/Error';
import School from '@material-ui/icons/School';
import Home from '@material-ui/icons/Home';
import Work from '@material-ui/icons/Work';
import Person from '@material-ui/icons/Person';

const MaterialSvgIconFactory = ({iconName}) => {

    switch (iconName.toLowerCase()) {
        case 'favorite':
            return <FavoriteIcon/>
        case 'venueandparking':
            return <Car/>
        case 'story':
            return <Book/>
        case 'weddingparty':
            return <People/>
        case 'photo':
            return <Photo/>
        case 'rsvp':
            return <RSVP/>
        case 'accomodations':
            return <Hotel/>
        case 'registry':
            return <Registry/>
        case 'songrequest':
            return <QueueMusic/>
        case 'guestbook':
            return <GuestBook/>
        case 'checkcircle':
            return CheckCircle;
        case 'error':
            return Error;
        case 'school':
            return <School/>;
        case 'home':
            return <Home/>;
        case 'work':
            return <Work/>;
        case 'person':
            return <Person/>;
        default:
            return <FavoriteIcon/>

    }
}

export default MaterialSvgIconFactory;


// WEBPACK FOOTER //
// ./src/icons/MaterialSvgIconFactory.js